module.exports = __webpack_public_path__ + "static/logo-c6f93de297c979195fe48ae174365f98.png";